import React, { useState, useEffect } from 'react';

const EventsPage = () => {
  const [events, setEvents] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/events`);
        if (response.ok) {
          const data = await response.json();
          setEvents(data);
        } else {
          setError('Failed to fetch events');
        }
      } catch (error) {
        setError('Error fetching events');
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  return (
    <div className="bg-white py-16 px-4 mt-12">
      <div className="container mx-auto">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-main-blue text-center mb-8 sm:mb-12">Events</h1>
        {error && <p className="text-red-500 text-center mb-4">{error}</p>}
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : events.length === 0 ? (
          <p className="text-center text-gray-500">There are no events at the moment.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {events.map((event) => (
              <div key={event.id} className="bg-white rounded-lg shadow-lg overflow-hidden transform hover:-translate-y-1 transition-transform duration-300">
                {event.imageUrl && (
                  <img src={`http://localhost:5000${event.imageUrl}`} alt={event.title} className="w-full h-48 object-cover" />
                )}
                <div className="p-6">
                  <h2 className="text-2xl font-bold text-[#364A9A] mb-2 font-poppins">{event.title}</h2>
                  <p className="text-gray-500 font-bold text-sm mb-1">
                    Event Start Date - {new Date(event.date).toLocaleDateString()}
                  </p>
                  
                  <p className="text-gray-700 mb-4">{event.description}</p>
                  <p className="text-gray-500 font-bold text-sm mb-4">
                    Event End Date - {new Date(event.endDate).toLocaleDateString()}
                  </p>
                  <p className="text-gray-500 text-sm">Location: {event.location}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EventsPage;
